import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import request, { blobFileRequest, downloadRequest } from './util/request';
import util from './util/util';
import 'assets/reset.styl';
import './util/element-ui';
import 'assets/global.styl';
import createAmap from './util/amap';
import echarts from 'echarts';
import common from './util/common';

createAmap();

Vue.config.productionTip = false;
Vue.prototype.$request = request;
Vue.prototype.$blobFileRequest = blobFileRequest;
Vue.prototype.$downloadRequest = downloadRequest;
Vue.prototype.$util = util;
Vue.prototype.$echarts = echarts;
Vue.prototype.$common = common;

new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app');
